// Enum para tipo de emissão de fatura
export const IssueBillingTypeEnum = {
  days_before_due_date: 0,
  specific_day: 1
} as const

export type IssueBillingType = keyof typeof IssueBillingTypeEnum

export const IssueBillingTypeLabels: Record<IssueBillingType, string> = {
  days_before_due_date: 'Dias antes do vencimento',
  specific_day: 'Dia específico do mês'
}

export type ModalParams = {
  open: boolean
  variant: 'view' | 'edit' | 'add' | 'detail' | 'nonPro' | null
  category:
    | 'before_due_date'
    | 'paid_billing'
    | 'after_due_date'
    | 'negativation'
    | null
  notifications: CustomTimelineParams | null
  uuid?: string | null
  item?: string
}

export interface CustomTimelineParams {
  paid_billing: PaidBilling
  after_due_date: AfterDueDate
  before_due_date: BeforeDueDate
  // SC-11742: notificações extras "Antes da negativação" (área Negativação).
  negativation?: NegativationGroup
}

export type NotificationItem = PaidBilling | AfterDueDate | BeforeDueDate

export interface Sms {
  message: string | null
  is_active: boolean
  default_message?: string
  fee?: string
}

export interface Email {
  message: string | null
  is_active: boolean
  default_message?: string
  subject?: string
  default_subject?: string
  fee?: string
}

export interface Whats {
  message: string | null
  is_active: boolean
  default_message?: string
  fee?: string
}

export interface SettingNotification {
  sms: Sms
  email: Email
  whats?: Whats
  is_active: boolean
  is_dirty?: boolean
}

export interface SettingNotificationExtra {
  uuid: string
  days: number
  interval_days?: number | null
  extra_type: string
  name: string
  notification_rules: SettingNotification
}

export interface AfterDueDate {
  billing_no_payment_report: SettingNotification
  charge_recurring_failed: SettingNotification
  change_status_to_overdue: SettingNotification
  notice_overdue_billing: SettingNotification
  extra_notifications: SettingNotificationExtra[]
}

export interface BeforeDueDate {
  in_due_date: SettingNotification
  billing_issue: SettingNotification
  extra_notifications: SettingNotificationExtra[]
}
export interface NegativationGroup {
  extra_notifications: SettingNotificationExtra[]
}

export interface PaidBilling {
  paid_billing: SettingNotification
  extra_notifications: SettingNotificationExtra[]
}
